import React, { useState } from 'react';
import { Box, Tabs, Tab, Tooltip } from '@mui/material';
import {
  Person as InfoIcon,
  AttachFile as FileIcon,
} from '@mui/icons-material';
import { CustomerProfile } from './CustomerProfile';
import { RoomFiles } from './RoomFiles';
import { Customer } from '../../../types';

interface ProfilePanelProps {
  customer: Customer | null;
  selectedChatId: string | null;
  onCustomerUpdate?: (updates: Partial<Customer>) => void;
}

export const ProfilePanel: React.FC<ProfilePanelProps> = ({
  customer,
  selectedChatId,
  onCustomerUpdate,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        variant="fullWidth"
        sx={{
          minHeight: 42,
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            minHeight: 42,
            py: 0,
          },
        }}
      >
        <Tab
          icon={
            <Tooltip title="顧客情報" placement="bottom">
              <InfoIcon fontSize="small" />
            </Tooltip>
          }
          aria-label="顧客情報"
        />
        <Tab
          icon={
            <Tooltip title="ファイル一覧" placement="bottom">
              <FileIcon fontSize="small" />
            </Tooltip>
          }
          aria-label="ファイル一覧"
        />
      </Tabs>

      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        {activeTab === 0 && (
          <CustomerProfile
            customer={customer}
            selectedChatId={selectedChatId}
            onCustomerUpdate={onCustomerUpdate}
          />
        )}
        {activeTab === 1 && (
          <RoomFiles selectedChatId={selectedChatId} />
        )}
      </Box>
    </Box>
  );
};
